import axios from "axios";

import {
  isAdminDashboardToken,
  shouldDeferUnauthorizedRecovery,
} from "../utils/impersonation";
import { recoverStoredAdminSession } from "../utils/impersonationRecovery";

import apiService from "./api";

class HeartbeatService {
  constructor() {
    this.intervalId = null;
    this.isRunning = false;
    this.failureCount = 0;
    this.maxFailures = 3;
  }

  async sendHeartbeat() {
    try {
      const token = localStorage.getItem("authToken");

      if (!token) {
        await this.handleInvalidToken();

        return false;
      }

      const response = await apiService.sendHeartbeat(token);

      if (response.status === 200 && response.data?.valid === true) {
        this.failureCount = 0;

        return true;
      }

      await this.handleInvalidToken();

      return false;
    } catch (error) {
      if (error.response?.status === 401 || error.response?.status === 403) {
        await this.handleInvalidToken();

        return false;
      }

      this.failureCount++;

      return true;
    }
  }

  async handleInvalidToken() {
    if (shouldDeferUnauthorizedRecovery()) return;

    const token = localStorage.getItem("authToken");

    if (isAdminDashboardToken(token)) return;

    const restored = await recoverStoredAdminSession({ redirect: false }).catch(
      () => null
    );

    if (restored) return;

    if (shouldDeferUnauthorizedRecovery()) return;

    this.stop();
    localStorage.removeItem("authToken");
    delete axios.defaults.headers.common["Authorization"];
    const currentPath = window.location.pathname;

    if (
      currentPath !== "/login" &&
      currentPath !== "/register" &&
      currentPath !== "/forgot-password" &&
      currentPath !== "/reset-password"
    ) {
      window.location.href = "/login";
    }
  }

  start() {
    if (this.isRunning) {
      return;
    }

    const token = localStorage.getItem("authToken");

    if (!token) {
      return;
    }

    this.isRunning = true;
    this.failureCount = 0;

    this.sendHeartbeat();

    this.intervalId = setInterval(() => {
      this.sendHeartbeat();
    }, 30000);
  }

  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.isRunning = false;
    this.failureCount = 0;
  }

  restart() {
    this.stop();
    this.start();
  }
}

const heartbeatService = new HeartbeatService();

export default heartbeatService;
